import React from 'react';
export function HeroSection() {
  return <section aria-label="Presentación del ProfePack" className="bg-brand-dark text-white md:pt-20 pb-8 md:pb-12 px-4 pt-[10px]" data-id="element-136">
      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center" data-id="element-137">
        <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-2 md:mb-8" data-id="element-138">
          <span className="text-xl" aria-hidden="true" data-id="element-139">
            🧮
          </span>{' '}
          PROFEPACK
        </div>

        <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-sans leading-[0.95] mt-[-10px] mb-[-10px] md:mt-[-20px] md:mb-[-20px]" data-id="element-140">
          Todo tu año de Matemática
          <br data-id="element-141" />
          <span className="text-brand-accent" data-id="element-142">resuelto.</span>
        </h1>

        <div className="w-full max-w-[270px] sm:max-w-sm md:max-w-xl mx-auto mt-4 md:mt-12 mb-3 md:mb-12" data-id="element-143">
          <img src="https://cdn.magicpatterns.com/uploads/p5uukvc9r3hYXLcg8oon7N/PROYECTOS-Anuales-_1080-x-900-px_-_5_.webp" alt="Megapack Matemática Lista — 12 tomos completos para docentes de primaria y secundaria" className="w-full h-auto" loading="eager" decoding="async" fetchPriority="high" sizes="(max-width: 640px) 270px, (max-width: 768px) 384px, 576px" width={1080} height={900} data-id="element-144" />
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-145">
          <p className="text-base sm:text-xl md:text-3xl text-brand-accent font-heading font-bold md:mb-6 px-2 mb-[2px]" data-id="element-146">
            "Listo para usar. Sin buscar más."
          </p>

          <p className="text-sm md:text-xl text-white/80 md:mb-10 leading-relaxed px-2 mb-[6px]" data-id="element-147">
            El sistema que usan +2.000 docentes de Matemática de primaria y
            secundaria en Argentina para planificar{' '}
            <span className="text-white font-bold" data-id="element-148">
              todo el año en una tarde
            </span>{' '}
            — sin improvisar, sin buscar y sin perder domingos.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-4 mb-3 md:mb-10" data-id="element-149">
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90" data-id="element-150">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90" data-id="element-151">
              ⚡ Acceso inmediato
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-white/90" data-id="element-152">
              🇦🇷 Currículo argentino 2026
            </span>
          </div>

          <a href="#pricing" onClick={e => {
          e.preventDefault();
          const doScroll = () => {
            const el = document.getElementById('pricing');
            if (!el) return false;
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            return true;
          };
          if (!doScroll()) {
            let attempts = 0;
            const interval = setInterval(() => {
              attempts++;
              if (doScroll() || attempts > 50) {
                clearInterval(interval);
              }
            }, 100);
          }
        }} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-brand-dark font-black md:text-3xl py-4 md:py-6 px-6 md:px-14 rounded-2xl transition-colors flex items-center justify-center md:mb-8 mx-4 sm:mx-0 text-[16px] mb-[12px] ml-[20px] mr-[20px] no-underline cursor-pointer" data-id="element-153">
            🧮 → QUIERO MI PROFEPACK AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-2 text-xs md:text-sm text-white/70 font-medium" data-id="element-154">
            <span data-id="element-155">🛡️ Garantía 7 días sin preguntas</span>
            <span data-id="element-156">🔒 Pago 100% seguro</span>
            <span data-id="element-157">💳 Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}